import { observable, action } from 'mobx';
import { Messages } from 'api';

class ChatStore {
  @observable.shallow messages = [];

  @observable fetchState;

  @observable messageState;

  anketId;

  @action.bound
  async getMessages(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Messages.getMessages(anketId);
      this.messages = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }

  @action.bound
  addMessage(message) {
    this.messages.push(message);
  }

  @action.bound
  async sendMessage(message) {
    this.messageState = 'pending';

    try {
      const response = await Messages.sendMessage(this.anketId, message);
      this.addMessage(response.data);
      this.messageState = 'fulfilled';
    } catch (e) {
      this.messageState = 'rejected';
    }
  }
}

const chatStore = new ChatStore();

export default chatStore;
